import { library } from "@fortawesome/fontawesome-svg-core";
import { 
  faHandsHelping, faBookOpen, faSeedling, faArrowRight,
  faHeart, faHandshake, faUsers, faLightbulb,
  faHandHoldingHeart, faBuilding, faMapMarkerAlt, faPhone, faEnvelope,
  faSun, faMoon
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";

// Add icons to the library
library.add(
  faHandsHelping,
  faBookOpen,
  faSeedling,
  faArrowRight,
  faFacebook,
  faTwitter,
  faInstagram,
  faHeart,
  faHandshake,
  faUsers,
  faLightbulb,
  faHandHoldingHeart,
  faBuilding,
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faSun,
  faMoon
);
